import { off } from "firebase/database";

const useFilterOffersToDisplay = (DownloadedOffers, MainFilter, SecondFilter, PriceFilter, FilteredMinPrice, FilteredMaxPrice, FilteredMinSquare, FilteredMaxSquare, FilteredMarket, FilteredCity, FilteredDistrict, FilteredStreet, CountryFilter, ExperienceFilter, SearchInputValue, CityFilter, CurrencyFilter) => {

// filtry muszą być podawane i odbierane w tej samej kolejności

      const offerPriceDisplay = (offer) => { 
         if (PriceFilter === false) {
           return offer
        } else if (PriceFilter === true) {
           return offer.price !== ""
        }
        };


          const offerMinPriceDisplay = (offer) => {
         // Jeśli filtr nieustawiony, pokazuj wszystkie oferty
         if (!FilteredMinPrice) return true;

          const offerPrice = Number(String(offer.price).replace(/\s/g, ''));
          const minPrice = Number(String(FilteredMinPrice).replace(/\s/g, ''));

          return offerPrice >= minPrice;
        };

        const offerMaxPriceDisplay = (offer) => {
   
          if (!FilteredMaxPrice) return true;

          const offerPrice = Number(String(offer.price).replace(/\s/g, ''));
          const maxPrice = Number(String(FilteredMaxPrice).replace(/\s/g, ''));

          return offerPrice <= maxPrice;
        };


            const offerMinSquareDisplay = (offer) => {
              if (!FilteredMinSquare) return true;

              const offerSquare = Number(String(offer.squareFootage).replace(/\s/g, ''));
              const minSquare = Number(String(FilteredMinSquare).replace(/\s/g, ''));

              return offerSquare >= minSquare;
         };

          const offerMaxSquareDisplay = (offer) => {
           if (!FilteredMaxSquare) return true;

            const offerSquare = Number(String(offer.squareFootage).replace(/\s/g, ''));
            const maxSquare = Number(String(FilteredMaxSquare).replace(/\s/g, ''));

            return offerSquare <= maxSquare;
         };

      const offerMarketDisplay = (offer) => { 

         if (!FilteredMarket || FilteredMarket === '' || FilteredMarket === 'Wybierz') {
           return offer
        } else if (FilteredMarket) {
           return offer.market === FilteredMarket
        }
        };



          const searchInputValues = (offer) => {

            const searchArray = SearchInputValue.split(' ')

              if (SearchInputValue.length === 0) {
               return offer
              } else if (searchArray.length === 1) {
                return offer.title.toLowerCase().includes(searchArray[0].toLowerCase())
              } else if (searchArray.length === 2) {
                return offer.title.toLowerCase().includes(searchArray[0].toLowerCase()) && offer.title.toLowerCase().includes(searchArray[1].toLowerCase())
              } else if (searchArray.length === 3) {
                return offer.title.toLowerCase().includes(searchArray[0].toLowerCase()) && offer.title.toLowerCase().includes(searchArray[1].toLowerCase()) && offer.title.toLowerCase().includes(searchArray[2].toLowerCase())
              } else if (searchArray.length > 3) {
                return
            }
          };


         const showFilteredCity = (offer) => {
                if (!FilteredCity) {
                   return offer
                } else if (FilteredCity) {
                   return offer.city.toLowerCase().includes(FilteredCity.toLowerCase())
                }
          }; 

         const showFilteredDistrict = (offer) => {
                if (!FilteredDistrict) {
                   return offer
                } else if (FilteredDistrict && offer.hasOwnProperty('district')) {
                   return offer.district.toLowerCase().includes(FilteredDistrict.toLowerCase())
                } 
          }; 


         const showFilteredStreet = (offer) => {
                if (!FilteredStreet) {
                   return offer
                } else if (FilteredStreet && offer.hasOwnProperty('street')) {
                   return offer.street.toLowerCase().includes(FilteredStreet.toLowerCase())
                }
          }; 
   
          const roleFilterValues = (offer) => {
            if (!MainFilter) {
               return offer
            } else if (MainFilter) {
               return offer.MainCategory === MainFilter
            }
          };

          const specialityFilterValues = (offer) => {
            if (!SecondFilter) {
               return offer
            } else if (SecondFilter) {
               return offer.SubCategory === SecondFilter
            }
          };

          const experienceFilterValues = (offer) => {
            if (!ExperienceFilter) {
               return offer
            } else if (ExperienceFilter) {
               return offer.experience === ExperienceFilter
            }
          };

          const currencyFilterValues = (offer) => {
             if (!CurrencyFilter) {
               return offer
             } else if (CurrencyFilter) {
               return offer.currency === CurrencyFilter
             }
          };

         if (DownloadedOffers) {
            return DownloadedOffers.filter( offer => searchInputValues(offer)  && roleFilterValues(offer) && specialityFilterValues(offer) && experienceFilterValues(offer) && currencyFilterValues(offer) && offerPriceDisplay(offer) && offerMinPriceDisplay(offer) && offerMaxPriceDisplay(offer) && offerMinSquareDisplay(offer) && offerMaxSquareDisplay(offer) && offerMarketDisplay(offer) && showFilteredCity(offer) && showFilteredDistrict(offer) && showFilteredStreet(offer))
        }
        };



export default useFilterOffersToDisplay;